export const CSRF_COOKIE_KEY = 'XSRF-TOKEN';
export const CSRF_HEADER_KEY = 'X-XSRF-TOKEN';
